<div class="relative overflow-x-auto shadow-md sm:rounded-lg p-5">
  <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white dark:bg-gray-900">
    <label for="table-search" class="sr-only">Search</label>
    <div class="relative">
      <div class="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none">
        <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
        </svg>
      </div>
      <input type="text" id="table-search" [(ngModel)]="searchTerm" class="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Cerca">
    </div>
    <!-- Pulsante all'estremità opposta -->
    <button
      type="button"
      class="text-white bg-blue-700 hover:bg-blue-800 font-medium text-sm px-4 py-2 rounded-md"
      (click)="aggiungiBlocco()"
    >
      Aggiungi Blocco
    </button>

  </div>
  <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
    <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
    <tr>
      <th scope="col" class="px-6 py-3">
        Nome
      </th>
      <th scope="col" class="px-6 py-3">
        Telefono
      </th>
      <th scope="col" class="px-6 py-3">
        Elimina
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let block of filteredBockList" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600">
      <td class="items-center px-6 py-4 text-gray-900 whitespace-nowrap ">
        <div>
          <div class="text-base font-semibold">{{ block.nome }}</div>
        </div>
      </td>
      <td class="px-6 py-4">
        {{ block.telefono }}
      </td>
      <td class="px-8 py-4">
        <button
          class="bg-red-600 rounded-full w-10 h-10 flex justify-center items-center"
          (click)="deleteBlock(block)"
        >
          <svg class="w-8 h-8 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
          </svg>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>

